import React, { useState, useContext } from "react";
import { Grid, makeStyles, Button, TextField as MaterialTextField, FormControl } from "@material-ui/core";
import { useForm } from "react-hook-form";
import { AuthContext } from "../context";
import { userServices } from "../services";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { ModalBase, TextField } from "./";

export default function EditBusinessUnit(props) {
	const classes = useStyles();
	const { laboratory } = props;
	const [specialties, setSpecialties] = useState(laboratory.specialties);
	const { register, handleSubmit, errors } = useForm();
	const { authState } = useContext(AuthContext);

	const updateLaboratory = async (dataToInsert) => {
		const laboratory = {
			username: dataToInsert.username,
			email: dataToInsert.email,
			laboratory: {
				name: dataToInsert.name,
				specialties,
			},
		};
		try {
			const { status, response } = await userServices.updateUser({
				_id: props.laboratory.user._id,
				user: laboratory,
				token: authState.token,
			});
			switch (status) {
				case 200:
					if (response.error) {
						props.toast(response.error.message, true);
					} else {
						props.toast("Usuario actualizado con exito", true);
						props.reload();
						props.close();
					}
					break;
				case 400:
					props.toast(response.error.message, true);
					break;
				default:
					break;
			}
		} catch (e) {
			console.log(e);
		}
	};

	return (
		<ModalBase open={props.open} close={props.close} title="Editar unidad de negocio">
			<form className={classes.form} onSubmit={handleSubmit(updateLaboratory)}>
				<Grid container spacing={2}>
					<Grid item xs={12} sm={12}>
						<TextField
							variant="outlined"
							fullWidth
							id="name"
							label="Nombre"
							name="name"
							placeholder="Nombre"
							autoComplete="name"
							defaultValue={laboratory.name}
							size="small"
							inputRef={register({
								required: "Nombre requerido",
							})}
							InputLabelProps={{
								shrink: true,
							}}
							error={errors.name ? true : false}
							helperText={errors.name ? errors.name.message : ""}
						/>
					</Grid>
					<Grid item xs={12} sm={12}>
						<TextField
							variant="outlined"
							fullWidth
							id="email"
							placeholder="Correo electrónico"
							label="Correo electrónico"
							name="email"
							size="small"
							autoComplete="email"
							defaultValue={laboratory.user.email}
							inputRef={register({
								required: "Correo requerido",
								pattern: {
									value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
									message: "Formato de correo inválido",
								},
							})}
							InputLabelProps={{
								shrink: true,
							}}
							error={errors.email ? true : false}
							helperText={errors.email ? errors.email.message : ""}
						/>
					</Grid>
					<Grid item xs={12} sm={12}>
						<TextField
							variant="outlined"
							fullWidth
							id="username"
							label="Usuario"
							name="username"
							placeholder="Usuario"
							size="small"
							autoComplete="username"
							defaultValue={laboratory.user.username}
							inputRef={register({
								required: "Usuario requerido",
							})}
							InputLabelProps={{
								shrink: true,
							}}
							error={errors.username ? true : false}
							helperText={errors.username ? errors.username.message : ""}
						/>
					</Grid>
					<Grid item lg={12} xs={12} sm={12}>
						<FormControl variant="outlined" className={`${classes.formControl}  ${classes.shrinkLabel}`}>
							<Autocomplete
								multiple
								id="especialidades"
								options={authState.user.laboratory.specialties.filter((specialty) =>
									laboratory.specialties.find((obj) => obj._id !== specialty._id)
								)}
								getOptionLabel={(option) => option.name}
								filterSelectedOptions
								variant="outlined"
								label="Especialidades"
								value={specialties}
								onChange={(event, newValue) => {
									setSpecialties(newValue);
								}}
								renderInput={(params) => (
									<MaterialTextField
										{...params}
										id="especialidades"
										name="especialidades"
										variant="outlined"
										label="especialidades"
										placeholder="Especialidades"
										inputRef={register({
											validate: (value) => specialties.length || "Debe tener al menos una especialidad.",
										})}
										error={errors.especialidades ? true : false}
										helperText={errors.especialidades ? errors.especialidades.message : ""}
									/>
								)}
							/>
						</FormControl>
					</Grid>
				</Grid>
				<Button
					type="submit"
					fullWidth
					size="small"
					variant="contained"
					color="primary"
					className={classes.submit}
					style={{ textTransform: "capitalize", borderRadius: "20px" }}
				>
					Guardar
				</Button>
			</form>
		</ModalBase>
	);
}

const useStyles = makeStyles((theme) => ({
	form: {
		marginTop: theme.spacing(2),
	},
	submit: {
		margin: theme.spacing(3, 0, 2),
	},
	textField: {
		width: "100%",
	},
	dialogTitle: {
		textAlign: "Center",
	},
	formControl: {
		width: "100%",
		minWidth: 120,
		"& div": {
			borderRadius: 25,
		},
	},
	shrinkLabel: {
		"& > label:nth-child(1)": {
			transform: "translate(14px, -6px) scale(0.75)",
		},
		"& > div:nth-child(2)": {
			"& > fieldset": {
				"& > legend": {
					maxWidth: 1000,
				},
			},
		},
	},
}));
